// src/pages/CategoryPage.jsx

import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config";

const CategoryPage = () => {
  const [form, setForm] = useState({
    company_id: "",
    name: "",
    is_medical: "0",
  });

  const [companies, setCompanies] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filterText, setFilterText] = useState("");

  // --- Edit modal state ---
  const [showEdit, setShowEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({
    company_id: "",
    name: "",
    is_medical: "0",
  });

  /* ===========================================
   *  LOADERS
   * ===========================================
   */
  const loadCompanies = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/companies", {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

      const d = res.data;
      let arr = [];
      if (Array.isArray(d)) arr = d;
      else if (Array.isArray(d.data)) arr = d.data;
      else if (Array.isArray(d.companies)) arr = d.companies;

      setCompanies(arr || []);
    } catch (err) {
      console.error("Companies load error:", err);
      toast.error("Failed to load companies");
    }
  };

  const loadCategories = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/categories", {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

      const d = res.data;
      let arr = [];
      if (Array.isArray(d)) arr = d;
      else if (Array.isArray(d.data)) arr = d.data;
      else if (Array.isArray(d.categories)) arr = d.categories;

      setCategories(arr || []);
    } catch (err) {
      console.error("Categories load error:", err);
      toast.error("Failed to load categories");
    }
  };

  useEffect(() => {
    loadCompanies();
    loadCategories();
  }, []);

  /* ===========================================
   *  ADD CATEGORY FORM
   * ===========================================
   */
  const handleInput = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(API_BASE_URL + "/categories", form, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

toast.success("Category added successfully!!");

      setForm({
        company_id: "",
        name: "",
        is_medical: "0",
      });

      loadCategories();
    } catch (err) {
      if (err.response?.status === 422 && err.response.data.errors) {
        Object.values(err.response.data.errors).forEach((msg) =>
          toast.error(msg[0])
        );
      } else {
        console.error("Add category error:", err);
        toast.error("Error adding category",{
  position: "buttom-right",
});
      }
    }
  };

  /* ===========================================
   *  DELETE CATEGORY
   * ===========================================
   */
 const deleteCategory = async (id) => {
  if (!window.confirm("Delete this category?")) return;

  try {
    await axios.delete(API_BASE_URL + `/categories/${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });

 toast.success("Category Deleted successfully!")

    loadCategories();
  } catch (err) {
    console.error("Delete category error:", err);
    toast.error("Error deleting category");
  }
};


  /* ===========================================
   *  EDIT CATEGORY (MODAL)
   * ===========================================
   */
  const openEditModal = async (row) => {
    try {
      const res = await axios.get(API_BASE_URL + `/categories/${row.assets_category_id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

      const d = res.data.data;

      setEditId(d.id);
      setEditForm({
        company_id: d.company_id,
        name: d.category_name,
        is_medical: String(d.is_medical ?? "0"),
      });
      setShowEdit(true);
    } catch (err) {
      console.error("Load category error:", err);
      toast.error("Failed to load category");
    }
  };

  const handleEditInput = (e) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      await axios.put(API_BASE_URL + `/categories/${editId}`, editForm, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });
toast.success("Category updated successfully!", {
position: "bottom-right",
});

      setShowEdit(false);
      loadCategories();
    } catch (err) {
      if (err.response?.status === 422 && err.response.data.errors) {
        Object.values(err.response.data.errors).forEach((msg) =>
          toast.error(msg[0])
        );
      } else {
        console.error("Update category error:", err);
        toast.error("Error updating category");
      }
    }
  };

  /* ===========================================
   *  DATATABLE
   * ===========================================
   */
  const columns = [
    {
  name: "Action",
  width: "100px",
  cell: (row) => (
    <>
      <button
        className="border-0 bg-transparent me-2"
        title="Edit"
        onClick={() => openEditModal(row)}
        style={{ cursor: "pointer" }}
      >
        <i className="fa fa-pencil text-warning" style={{ fontSize: "18px" }}></i>
      </button>

      {/* <button
        className="border-0 bg-transparent"
        title="Delete"
        onClick={() => deleteCategory(row.assets_category_id)}
        style={{ cursor: "pointer" }}
      >
        <i className="fa fa-trash text-danger" style={{ fontSize: "18px" }}></i>
      </button> */}
    </>
  ),
},

    {
      name: "Category Name",
      selector: (row) => row.category_name,
      sortable: true,
    },
    {
      name: "Company",
      selector: (row) => row.company_name,
      sortable: true,
    },
    {
      name: "Medical?",
      selector: (row) =>
        row.is_medical === 1 || row.is_medical === "1" ? "Yes" : "No",
      sortable: true,
      width: "100px",
    },
  ];

  const filteredItems = (categories || []).filter((item) => {
    const txt = filterText.toLowerCase();
    return (
      item.category_name?.toLowerCase().includes(txt) ||
      item.company_name?.toLowerCase().includes(txt)
    );
  });

  /* ===========================================
   *  RENDER
   * ===========================================
   */
  return (
    <div className="container mt-4">
     <ToastContainer position="bottom-right" />


      <div className="row">
        {/* LEFT FORM */}
        <div className="col-md-4">
          <div className="card shadow-sm">
            <div className="card-header">
              <strong>Add New Category</strong>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                {/* Company */}
                <div className="mb-3">
                  <label className="form-label">
                    Company 
                  </label>
                  <Select classNames={{
    control: () => "required-select required-tooltip"
  }}
                    options={(companies || []).map((c) =>
                      c.label && c.value
                        ? c
                        : {
                            label: c.name,
                            value: c.company_id,
                          }
                    )}
                    value={
                      (companies || [])
                        .map((c) =>
                          c.label && c.value
                            ? c
                            : {
                                label: c.name,
                                value: c.company_id,
                              }
                        )
                        .find((opt) => opt.value === form.company_id) || null
                    }
                    onChange={(selected) =>
                      setForm((prev) => ({
                        ...prev,
                        company_id: selected ? selected.value : "",
                      }))
                    }
                    placeholder="Select company..."
                    className="form-control p-0"
                  />
                </div>

                {/* Category Name */}
                <div className="mb-3 required-tooltip">
                  <label className="form-label">
                    Category Name 
                  </label>
                  <input
                    type="text"
                    name="name"
                    className="form-control required-input "
                    value={form.name}
                    onChange={handleInput}
                  />
                </div>

                {/* Medical */}
                <div className="mb-3">
                  <label className="form-label">Medical Equipment?</label>
                  <select
                    name="is_medical"
                    className="form-control"
                    value={form.is_medical}
                    onChange={handleInput}
                  >
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                  </select>
                </div>

                <button type="submit" className="btn btn-primary w-100">
                  Save Category
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* RIGHT TABLE */}
        <div className="col-md-8">
          <div className="card shadow-sm">
            <div className="card-header d-flex justify-content-between align-items-center">
              <strong>Category List</strong>
              <input
                type="text"
                className="form-control form-control-sm d-inline-block"
                style={{ width: "200px" }}
                placeholder="Search..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </div>
            <div className="card-body">
              <DataTable
                columns={columns}
                data={filteredItems}
                pagination
                highlightOnHover
                striped
                persistTableHead
              />
            </div>
          </div>
        </div>
      </div>

      {/* EDIT MODAL (simple bootstrap-style) */}
      {showEdit && (
        <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={handleUpdate}>
                <div className="modal-header">
                  <h5 className="modal-title">Edit Category</h5>
                  <button
  type="button"
  onClick={() => setShowEdit(false)}
  style={{
    border: "none",
    background: "transparent",
    fontSize: "22px",
    cursor: "pointer",
  }}
>
  ✕
</button>

                </div>
                <div className="modal-body">
                  {/* Company */}
                  <div className="mb-3">
                    <label className="form-label">Company</label>
                    <Select  classNames={{
    control: () => "required-select required-tooltip"
  }}
                      options={(companies || []).map((c) =>
                        c.label && c.value
                          ? c
                          : {
                              label: c.name,
                              value: c.company_id,
                            }
                      )}
                      value={
                        (companies || [])
                          .map((c) =>
                            c.label && c.value
                              ? c
                              : {
                                  label: c.name,
                                  value: c.company_id,
                                }
                          )
                          .find((opt) => opt.value === editForm.company_id) ||
                        null
                      }
                      onChange={(selected) =>
                        setEditForm((prev) => ({
                          ...prev,
                          company_id: selected ? selected.value : "",
                        }))
                      }
                      placeholder="Select company..."
                      className="form-control p-0"
                    />
                  </div>

                  {/* Category Name */}
                  <div className="mb-3">
                    <label className="form-label">Category Name</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control required-input"
                      value={editForm.name}
                      onChange={handleEditInput}
                    />
                  </div>

                  {/* Medical */}
                  <div className="mb-3">
                    <label className="form-label">Medical Equipment?</label>
                    <select
                      name="is_medical"
                      className="form-control"
                      value={editForm.is_medical}
                      onChange={handleEditInput}
                    >
                      <option value="0">No</option>
                      <option value="1">Yes</option>
                    </select>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowEdit(false)}
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryPage;
